module.exports = "<!-- Main view/routes wrapper-->\r\n\r\n<router-outlet></router-outlet>\r\n\r\n"